<script setup lang="ts">
import { AlertQC } from '@qicgroupdoha/qic-connect-ds';

import { useNotificationsStore } from '../model/Notifications.store';

const notificationsStore = useNotificationsStore();
</script>

<template>
  <transition name="fade">
    <AlertQC
      v-if="notificationsStore.activeNotification"
      class="alert"
      :subtitle="notificationsStore.activeNotification.subtitle"
      closable
      variant="dark"
      @close="notificationsStore.removeNotification"
    />
  </transition>
</template>

<style lang="scss" scoped>
@use 'ToastNotification';
</style>
